import Skeleton from '@material-ui/lab/Skeleton';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { ArticleList, SkeletonList } from '@swf/help';
import type { Article, Category } from '@swf/help';

import {
  TXTWCL_Login_for_personalised_help,
  TXTWCL_Most_Viewed_Articles,
  TXTWCL_Recommended_for_You
} from './Home.messages.json';
import styles from './Home.scss';
import CategoryBoard from './components/CategoryBoard/CategoryBoard';
import LogIn from './components/LogIn/LogIn';

interface Props {
  categories?: Category[];
  articles?: Article[];
  suggestedArticlesType: string;
}

const articlesTypeRecommended = 'RECOMMENDED';
const articlesTypePopular = 'POPULAR';

const Home: React.FC<Props> = ({ categories, articles = [], suggestedArticlesType }) => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const articleList = articles.slice(0, 6);
  const hideLogin = useSelector(select.help.getShouldHideLogin);

  return (
    <>
      <section>
        {(!!articles?.length || !hideLogin) && (
          <div
            className={classNames(styles.contentWrapper, {
              [styles.horizontalWrapper]: !isAuthenticated
            })}
          >
            {suggestedArticlesType === articlesTypeRecommended && (
              <div>
                <h2 className={styles.title}>
                  <Translation {...TXTWCL_Recommended_for_You} />
                </h2>
                <ArticleList
                  articles={articles}
                  highlight
                  emphasizedCategory="responsible-gaming"
                />
              </div>
            )}
            {!hideLogin && (
              <div className={styles.loginWrapper}>
                <h2 className={styles.title}>
                  <Translation {...TXTWCL_Login_for_personalised_help} />
                </h2>
                <LogIn />
              </div>
            )}
            {suggestedArticlesType === articlesTypePopular && (
              <div className={styles.articles}>
                <h1 className={classNames(styles.title, styles.articleTitle)}>
                  <Translation {...TXTWCL_Most_Viewed_Articles} />
                </h1>
                <ArticleList
                  articles={articleList}
                  column={hideLogin ? 2 : 1}
                  listOnMobile={isAuthenticated}
                />
              </div>
            )}
          </div>
        )}
      </section>
      <section>
        <CategoryBoard categories={categories} />
      </section>
    </>
  );
};

export const HomeSkeleton = () => (
  <section className={styles.homeSkeleton}>
    <div className={styles.contentWrapper}>
      <div className={styles.articles}>
        <Skeleton variant="rect" width={250} height={30} className={styles.titleSkeleton} />
        <SkeletonList
          skeletonSizes={['90%', '65%', '75%', '45%']}
          height={50}
          className={styles.recommendedSkeleton}
        />
      </div>
    </div>
  </section>
);

export default Home;
